import { useMemo } from 'react';
import { ApolloClient, InMemoryCache } from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';
import { setContext } from '@apollo/client/link/context';
import { fieldPolicies } from './fieldPolicies';
import { SchemaLink } from '@apollo/client/link/schema';
// @ts-ignore
let apolloClient = null;

function createGraphqlClient(token: string | null) {
  const createIsomorphLink = () => {
    // SSR時はスキーマリンクを用いてネットワークコールによるQuery / Mutation実行を回避
    // https://www.apollographql.com/docs/react/performance/server-side-rendering/#avoiding-the-network-for-local-queries
    if (typeof window === 'undefined') {
      const { schema } = require('src/server/schema.js');
      return new SchemaLink({ schema, context: { token } });
    } else {
      const uploadLink = createUploadLink({
        uri: `${process.env.BASE_URL}${process.env.GRAPHQL_API_ENDPOINT}`,
        credentials: 'same-origin',
        headers: { 'Apollo-Require-Preflight': 'true' },
      });
      return uploadLink;
    }
  };

  const isomorphLink = createIsomorphLink();
  const authLink = setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : '',
      },
    };
  });

  return new ApolloClient({
    ssrMode: typeof window === 'undefined',
    // @ts-ignore
    link: authLink.concat(isomorphLink),
    cache: new InMemoryCache({
      typePolicies: {
        Query: {
          fields: fieldPolicies,
        },
      },
    }),
  });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const initializeGraphqlClient = (initialState: any = null, token: string | null = null) => {
  const _apolloClient = createGraphqlClient(token);

  // If your page has Next.js data fetching methods that use Apollo Client, the initial state
  // gets hydrated here
  if (initialState) {
    // @ts-ignore
    _apolloClient.cache.restore(initialState);
  }
  // For SSG and SSR always create a new Apollo Client
  if (typeof window === 'undefined') return _apolloClient;
  // Create the Apollo Client once in the client
  // @ts-ignore
  if (!apolloClient) apolloClient = _apolloClient;

  return _apolloClient;
};

// @ts-ignore
export const useApollo = (initialState) => {
  const store = useMemo(() => initializeGraphqlClient(initialState), [initialState]);
  return store;
};
